<ngx-legend-chart [legendItems]="chartLegend"></ngx-legend-chart>

